import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { JsonValidatorComponent } from 'src/app/shared/json-validator/json-validator.component';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private validatorComponent: JsonValidatorComponent, private sanitizer: DomSanitizer) { }

  private getDomainUrl(): string {
    return window.location.href;
  }
  public getIsUsnjServer() {
    var str = this.getDomainUrl()
    return str.search('-nj')
  }

  public getSantizeUrl(url: string) { // for resolving 'unsafe' keyword issues while image(svg) preview with base64
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public convertToBase64Data(mediaData, callBack) {
    let { fileData, fileType, acceptedTypes, maxSize, maxWidth, maxHeight, isFixed } = mediaData;
    let returnData = {
      "status": true,
      "msg": ''
    }

    /* let hasWhiteSpaceRegEx = new RegExp('\\s+');
    let fileName = fileData.name.substring(0, fileData.name.lastIndexOf('.'));
    if (this.validatorComponent.validateStrWithRegExp(hasWhiteSpaceRegEx, fileName) == true) {
      returnData.status = false;
      returnData.msg = 'Please upload filename without spaces';
      callBack(returnData);
      return;
    } */

    let fileExtension = fileData.name.substring(fileData.name.lastIndexOf('.') + 1);
    if (!acceptedTypes.some(each => each == fileExtension.toLowerCase())) {
      returnData.status = false;
      returnData.msg = `Please upload file with only ${acceptedTypes.join()} extensions`;
      callBack(returnData);
      return;
    } else {
      returnData.status = true;
    }
    const fReader = new FileReader();
    fReader.readAsDataURL(fileData);
    fReader.onloadend = (e) => {
      if (maxSize && (fileData.size / 1024) > maxSize) {
        returnData.status = false;
        returnData.msg = 'Please upload a file less than or equal to ' + maxSize + 'kb';
        callBack(returnData);
        return;
      }
      if (fileType == 'sound') {
        Object.assign(returnData, { "imageData": fReader.result });
        callBack(returnData);
      } else if (fileType == 'image') {
        const img: any = new Image();
        img.src = fReader.result;
        img.onload = () => {
          // if (fileType != 'sound' && (((maxWidth && (img.width > maxWidth)) || (maxHeight && (img.height > maxHeight))) ||
          //   (fixedWidth && (img.width != fixedWidth)) || (fixedHeight && (img.height != fixedHeight)))) {
          //   returnData.status = false;
          //   returnData.msg = `Please upload a file having dimensions ${maxWidth ?? fixedWidth} X ${maxHeight ?? fixedHeight}`;
          // }
          if (fileType != 'sound' &&
            (maxWidth && ((isFixed && (isFixed != 'height' && img.width != maxWidth)) || img.width > maxWidth)) ||
            (maxHeight && ((isFixed && (isFixed != 'width' && img.height != maxHeight)) || img.height > maxHeight))
          ) {
            returnData.status = false;
            returnData.msg = (isFixed) ? `Please upload a file having exact dimensions ${maxWidth} X ${maxHeight}` : `Please upload a file having within this dimensions ${maxWidth} X ${maxHeight}`;
          } else {
            returnData.status = true;
            Object.assign(returnData, { "imageData": fReader.result });
            returnData.msg = '';
          }
          callBack(returnData);
        };
      } else {
        Object.assign(returnData, { "imageData": fReader.result });
        callBack(returnData);
      }
    };
  }

  public convertToURLEncodeBase64(base64) {
    let encodedBase64 = btoa(base64);
    return encodedBase64;
  }
  public getDynaconData(category, key) {
    category = category ? category : 'dynacon_gmsCommonSettings';
    let dataList: any;
    if (localStorage.getItem(category)) {
      dataList = JSON.parse(localStorage.getItem(category));
    }
    if (dataList) {
      return dataList[key];
    } else {
      let defaultDynaconData = environment.dynaconStaticData;
      let ddData = defaultDynaconData[category];
      console.log("ddData", ddData[key])
      return ddData[key];
    }

  }
  convertToUTF(data) {
    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(data);
    var convertedData = this.convertToURLEncodeBase64(String.fromCharCode(...utf8Bytes));
    return convertedData
  }

  public getApiBaseUrl() {
    let connectAws = this.getDynaconData("dynacon_gmsCommonSettings", "connectAws");
    if (connectAws) {
      return this.getDynaconData("dynacon_gmsCommonSettings", "awsApiUrl");
    } else {
      return this.getDynaconData("dynacon_gmsCommonSettings", "apiUrl");
    }
  }
}